<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">

    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Cadastro usuário
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        maxlength="255"
                        class="required"
                        label="Nome"
                        :error="$v.userEdit.nome.$error"
                        @blur="$v.userEdit.nome.$touch()"
                        v-model="userEdit.nome"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        class="required"
                        label="E-mail"
                        maxlength="255"
                        :error="$v.userEdit.email.$error"
                        @blur="$v.userEdit.email.$touch()"
                        v-model="userEdit.email"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        class="required"
                        label="CPF"
                        v-mask="['###.###.###-##']"
                        :error="$v.userEdit.cpf.$error"
                        @blur="$v.userEdit.cpf.$touch()"
                        v-model="userEdit.cpf"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        class="required"
                        label="Celular"
                        v-mask="['(##) #####-####']"
                        :error="$v.userEdit.telefone.$error"
                        @blur="$v.userEdit.telefone.$touch()"
                        v-model="userEdit.telefone"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <tw-date-picker label="Data de nascimento"
                          class="required"
                          :error="$v.userEdit.dataNascimento.$error"
                          @blur="$v.userEdit.dataNascimento.$touch()"
                          v-model="userEdit.dataNascimento"/>
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <v-text-field outlined
                        :label="userEdit.id ? 'Senha antiga' : 'Nova senha'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        :class="userEdit.id ? '' : 'required'"
                        :hint="passwordMessages"
                        autocomplete="off"
                        :error="$v.userEdit.password.$error"
                        @blur="$v.userEdit.password.$touch()"
                        @click:append="showPassword = !showPassword"
                        v-model="userEdit.password"/>
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <v-text-field outlined
                        hide-details
                        :label="userEdit.id ? 'Nova senha' : 'Repetir nova senha'"
                        :append-icon="showMatchPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showMatchPassword ? 'text' : 'password'"
                        :class="userEdit.id ? '' : 'required'"
                        autocomplete="off"
                        :error="$v.userEdit.matchPassword.$error"
                        @blur="$v.userEdit.matchPassword.$touch()"
                        @click:append="showMatchPassword = !showMatchPassword"
                        v-model="userEdit.matchPassword"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="mr-2"
             :loading="loadingForm"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>

  </tw-custom-dialog>
</template>

<script>
import UserService from '@/api/user-service';
import {
  maxLength, email, required,
} from 'vuelidate/lib/validators';
import _ from 'lodash';
import { isValid } from '@/utils/validate-cpf';
import { validateRequired, validateMinLength, validatePassword } from './validate-user-password';

function resetEdit() {
  return {
    nome: null,
    email: null,
    cpf: null,
    telefone: null,
    dataNascimento: null,
    password: null,
    oldPassword: null,
    matchPassword: null,
  };
}

export default {
  props: {
    user: Object,
  },
  data() {
    return {
      userEdit: resetEdit(),
      passwordMessages: 'Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres',
      dialog: false,
      loadingForm: false,
      showMatchPassword: false,
      showPassword: false,
    };
  },
  watch: {
    dialog() {
      if (this.user) {
        this.userEdit = _.cloneDeep(this.user);
      } else {
        this.userEdit = resetEdit();
      }
      this.$v.$reset();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loadingForm = true;
      this.preparaDados();
      UserService.save(this.userEdit)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Usuário salvo', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
          this.limpaSenha();
        });
    },
    preparaDados() {
      if (this.userEdit.password === '') {
        this.limpaSenha();
      }
      if (this.userEdit.id) {
        this.userEdit.oldPassword = this.userEdit.password;
        this.userEdit.password = undefined;
      }
    },
    limpaSenha() {
      this.userEdit.password = undefined;
      this.userEdit.matchPassword = undefined;
    },
  },
  validations: {
    userEdit: {
      nome: {
        required,
      },
      email: {
        email,
        required,
      },
      cpf: {
        required,
        isValid,
      },
      telefone: {
        required,
      },
      dataNascimento: {
        required,
      },
      password: {
        required: validateRequired,
        minLength: validateMinLength,
        maxLength: maxLength(30),
        passwordValid: validatePassword,
      },
      matchPassword: {
        required: validateRequired,
        minLength: validateMinLength,
        maxLength: maxLength(30),
        passwordValid: validatePassword,
        sameAsPassword: function sameAs() {
          if (this.userEdit.id) {
            return true;
          }
          return this.userEdit.password === this.userEdit.matchPassword;
        },
      },
    },
  },
};
</script>
